import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fb2e3d20")

_pushScopeId("data-v-fb2e3d20")
const _hoisted_1 = { class: "statistics-three" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BreadCrumbs = _resolveComponent("BreadCrumbs")
  const _component_SectionTitle = _resolveComponent("SectionTitle")
  const _component_StatCategories = _resolveComponent("StatCategories")
  const _component_FrequentlyReports = _resolveComponent("FrequentlyReports")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_BreadCrumbs, { links: [{ to: 'statistics-three', name: 'adaptiveTop.statistics' }] }),
        _createVNode(_component_SectionTitle, {
          title: _ctx.$t('pages.statistics.title1'),
          class: "statistics-three__title"
        }, null, 8, ["title"]),
        _createVNode(_component_StatCategories),
        _createVNode(_component_SectionTitle, {
          title: _ctx.$t('pages.statistics.title2'),
          class: "statistics-three__title"
        }, null, 8, ["title"]),
        _createVNode(_component_FrequentlyReports)
      ])
    ])
  ]))
})